import { Helmet } from "react-helmet";
import styled from "styled-components";
import StartUpHero from "../../assets/startup.jpg";
import NewProducts from "./NewProducts";

const Products = () => {
  // const [variety, setVariety] = useState(true);

  return (
    <>
      <Helmet>
        <title>Medichy | Products</title>
        <meta
          name="description"
          content="Medichy is a modern digital medical and healthcare platform delivering reliable medical and healthcare solutions."
        />
      </Helmet>
      <TheProducts>
        <div className="product-hero-section">
          <img src={StartUpHero} alt="page banner" />
          <div className="overlay"></div>
          <div className="hero-content">
            <h3>Products</h3>
            <p>
              Our core goal is to build on demand but this are the list of
              available . We do not sell less than the MOQ.
            </p>
          </div>
        </div>


        <div className="product-container">
          <NewProducts />
        </div>
      </TheProducts>
    </>
  );
};

const TheProducts = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  .product-hero-section {
    position: relative;
    height: 30vh;
    width: 100%;
    overflow: hidden;
    margin-bottom: 2rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 900px;
      padding: 0 1rem;

      h3 {
        font-size: 3.5rem;
        font-weight: 700;
        margin-bottom: 1rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        line-height: 1;
      }

      p {
        font-size: 1.25rem;
        font-weight: 400;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 2rem;
        line-height: 1.2;
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: transparent;
        color: white;
        border: 2px solid white;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: white;
          color: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }
  .variety-controls {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    .buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      width: 25%;
      background-color: #f0f0f0;
      padding: 1.2rem 0;
      button {
        cursor: pointer;
        width: 45%;
        border: none;
        padding: 0.5rem 0;
        font-size: 1rem;
        letter-spacing: 1px;
        background: #929191;
        transition: var(--transition);
        &:hover {
          background: #b9b9b9;
          transition: var(--transition);
        }
      }
      .active-btns {
        cursor: pointer;
        width: 45%;
        border: none;
        padding: 0.5rem 0;
        font-size: 1rem;
        letter-spacing: 1px;
        background: #d0cfcf;
        transition: var(--transition);
        &:hover {
          background: #b9b9b9;
          transition: var(--transition);
        }
      }
    }
  }
  .product-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    /* background: #f0f0f0; */
    margin-bottom: 2rem;
    border-radius: 0.5rem;
  }
  @media screen and (max-width: 420px){
    .product-container{
      padding: 0 0.5rem;
    }
  }
`;
export default Products;
